import React, { useEffect } from "react"
import { Badge, Card, CardBody, CardTitle, Col, Row, Table } from "reactstrap"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import Breadcrumbs from "components/Common/Breadcrumb"
import BackButton from "components/Shared/BackButton"
import { ShimmerThumbnail } from "react-shimmer-effects"
import { getIssueTypeDetails } from "store/actions/customerSupportAction"
import isPermissionEnabled from "common/isPermissionEnabled"
import { useTranslation } from "react-i18next"

const IssueDetails = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t(`Support Issue Details | Sign Burger`)

  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")

  const { userRole, accountType } = useSelector(state => state.Login)

  useEffect(() => {
    const isPermissionView = isPermissionEnabled(
      userRole,
      17,
      "customer_support_1",
      accountType
    )
    if (!isPermissionView) {
      navigate("/dashboard")
    }
  }, [])

  const { loading, issueTypeDetails } = useSelector(
    state => state.CustomerSupport
  )

  useEffect(() => {
    const fetchOldDetails = () => {
      const payload = {
        id,
      }
      dispatch(getIssueTypeDetails(payload))
    }
    fetchOldDetails()
  }, [])

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody>
                <CardTitle className="d-flex align-items-center">
                  <BackButton /> {t("Support Issue Details")}
                </CardTitle>
                <p className="text-muted mb-4"></p>
                <div className="table-responsive">
                  {loading ? (
                    <ShimmerThumbnail height={650} rounded />
                  ) : Object.values(issueTypeDetails).length === 0 ? (
                    <p className="text-center">{t("No support issue details found")}</p>
                  ) : (
                    <Table className="table-nowrap mb-0 capitalize_td">
                      <tbody>
                        <tr>
                          <th scope="row">{t("Id")}</th>
                          <td>{issueTypeDetails._id}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Title(English)")}</th>
                          <td>{issueTypeDetails?.title}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Title(عربي)")}</th>
                          <td>{issueTypeDetails?.titleAr}</td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Display Order")}</th>
                          <td>{issueTypeDetails.displayOrder ?? "-"}</td>
                        </tr>

                        <tr>
                          <th scope="row">{t("Is Attachment Required")}</th>
                          <td>
                            {issueTypeDetails?.isAttachmentRequired ? (
                              <Badge className="bg-success">{t("Yes")}</Badge>
                            ) : (
                              <Badge className="bg-danger">{t("No")}</Badge>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">{t("Status")}</th>
                          <td>
                            {issueTypeDetails?.status === 1 ? (
                              <Badge className="bg-success">{t("Active")}</Badge>
                            ) : (
                              <Badge className="bg-danger">{t("Deactive")}</Badge>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default IssueDetails
